import { useId, type ReactNode } from "react";
import estilos from "./Tarjeta.module.css";

export interface PropsTarjeta {
  /** Con título la tarjeta es una sección con nombre (landmark region). */
  readonly titulo?: ReactNode;
  /** Texto o acción al lado derecho del título. */
  readonly extra?: ReactNode;
  readonly sinLinea?: boolean;
  readonly className?: string | undefined;
  readonly children?: ReactNode;
}

export function Tarjeta({ titulo, extra, sinLinea, className, children }: PropsTarjeta) {
  const id = useId();
  const clases = [estilos.tarjeta, className].filter(Boolean).join(" ");
  if (titulo === undefined) return <div className={clases}>{children}</div>;
  return (
    <section className={clases} aria-labelledby={id}>
      <div className={[estilos.encabezado, sinLinea && estilos.sinLinea].filter(Boolean).join(" ")}>
        <h2 id={id}>{titulo}</h2>
        {extra !== undefined && <div className={estilos.extra}>{extra}</div>}
      </div>
      {children}
    </section>
  );
}

/** Bloque con el relleno de la tarjeta. */
export function CuerpoTarjeta({ children, className }: { readonly children: ReactNode; readonly className?: string }) {
  return <div className={[estilos.cuerpo, className].filter(Boolean).join(" ")}>{children}</div>;
}
